export default [
    {
        path: "/",
        name: "Home",
        component: () => import("./pages/MainPage/MainPage.new.vue")
    },
    {
        path: "/old",
        name: "OldHome",
        component: () => import("./pages/MainPage/MainPage.vue")
    },
    {
        path: "/exemplo",
        name: "Example",
        component: () => import("./pages/MainPage/MainPageModern.example.vue")
    },
    {
        path: "/projeto/:id",
        name: "ProjectDetails",
        component: () => import("./pages/Portfolio/ProjectDetails.vue")
    },
    {
        path: "/consultoria-gamificacao",
        name: "ConsultoriaGamificacao",
        component: () => import("./pages/ConsultoriaGamificacao/ConsultoriaGamificacao.vue")
    },
    // ============================================
    // Demo Sites Routes
    // ============================================
    {
        path: "/demo/hamburgueria",
        name: "DemoHamburgueria",
        component: () => import("./pages/DemoSites/HamburgueriaDemo.vue"),
        meta: { hideHeader: true, hideFooter: true, title: 'Modelo: Hamburgueria | Unli' }
    },
    {
        path: "/demo/hamburgueria/cardapio",
        name: "DemoHamburgueriaCardapio",
        component: () => import("./pages/DemoSites/HamburgueriaCardapio.vue"),
        meta: { hideHeader: true, hideFooter: true, title: 'Cardápio | House of Burgers' }
    },
    {
        path: "/demo/loja-roupas",
        name: "DemoLojaRoupas",
        component: () => import("./pages/DemoSites/LojaRoupasDemo.vue"),
        meta: { hideHeader: true, hideFooter: true, title: 'Modelo: Loja de Roupas | Unli' }
    },
    {
        path: "/demo/clinica-estetica",
        name: "DemoClinicaEstetica",
        component: () => import("./pages/DemoSites/ClinicaEsteticaDemo.vue"),
        meta: { hideHeader: true, hideFooter: true, title: 'Modelo: Clínica de Estética | Unli' }
    },
    {
        path: "/demo/serralheria",
        name: "DemoSerralheria",
        component: () => import("./pages/DemoSites/SerralheriaDemo.vue"),
        meta: { hideHeader: true, hideFooter: true, title: 'Modelo: Serralheria | Unli' }
    },

    // ============================================
    // Webinar Landing Page
    // ============================================
    {
        path: "/webinar",
        name: "WebinarPage",
        component: () => import(/* webpackPreload: true */ "./pages/WebinarPage/WebinarPage.vue"),
        meta: { hideHeader: true, hideFooter: true, title: 'Webinar Gratuito · IA e Automação | Foorge' }
    },

    // ============================================
    // Empresas do Futuro — Mentoria
    // ============================================
    {
        path: "/empresas-do-futuro",
        name: "EmpresasDoFuturo",
        component: () => import("./pages/EmpresasDoFuturo/EmpresasDoFuturo.vue"),
        meta: { title: 'Mentoria Empresas do Futuro · IA, Automação e Gamificação | Unli Studio' }
    },

    {
        path: "/configurador",
        name: "ConfiguradorPage",
        component: () => import("./pages/ConfiguradorPage/ConfiguradorPage.vue")
    },
    {
        path: "/pagamento/validar",
        name: "PaymentValidation", 
        component: () => import("./pages/PaymentValidation.vue")
    },
    {
        path: "/sucesso",
        name: "PaymentSuccess",
        component: () => import("./pages/PaymentSuccess.vue")
    },
    {
        path: "/setup",
        name: "OnboardingSetup",
        component: () => import("./pages/OnboardingSetup/OnboardingSetup.vue"),
        meta: {
            title: 'Configure seu Site | Unli',
            hideHeader: true,
            hideFooter: true
        }
    },

    // ============================================
    // SDR Panel Routes
    // ============================================
    {
        path: "/sdr",
        name: "SDRLogin",
        component: () => import("./pages/SDRPanel/SDRLogin.vue"),
        meta: { hideHeader: true, hideFooter: true }
    },
    {
        path: "/sdr/dashboard",
        name: "SDRDashboard",
        component: () => import("./pages/SDRPanel/SDRDashboard.vue"),
        meta: { hideHeader: true, hideFooter: true, requiresSDR: true }
    },
    {
        path: "/sdr/calculadora",
        name: "SDRCalculadora",
        component: () => import("./pages/SDRPanel/SDRCalculadora.vue"),
        meta: { hideHeader: true, hideFooter: true, requiresSDR: true }
    },
    {
        path: "/sdr/nova-venda",
        name: "SDRNovaVenda",
        component: () => import("./pages/SDRPanel/SDRNovaVenda.vue"),
        meta: { hideHeader: true, hideFooter: true, requiresSDR: true }
    },
    {
        path: "/sdr/clientes",
        name: "SDRClientes",
        component: () => import("./pages/SDRPanel/SDRClientes.vue"),
        meta: { hideHeader: true, hideFooter: true, requiresSDR: true }
    },
    {
        path: "/sdr/cliente/:id",
        name: "SDRClienteDetalhe",
        component: () => import("./pages/SDRPanel/SDRClienteDetalhe.vue"),
        meta: { hideHeader: true, hideFooter: true, requiresSDR: true }
    },
    {
        path: "/sdr/configuracoes",
        name: "SDRConfiguracoes",
        component: () => import("./pages/SDRPanel/SDRConfiguracoes.vue"),
        meta: { hideHeader: true, hideFooter: true, requiresSDR: true }
    },

    // ============================================
    // Affiliate Panel Routes
    // ============================================
    {
        path: "/afiliados",
        name: "AffiliateLogin",
        component: () => import("./pages/AffiliatePanel/AffiliateLogin.vue"),
        meta: { hideFooter: true }
    },
    {
        path: "/afiliados/registro",
        name: "AffiliateRegister",
        component: () => import("./pages/AffiliatePanel/AffiliateRegister.vue"),
        meta: { hideFooter: true }
    },
    {
        path: "/afiliados/esqueci-senha",
        name: "AffiliateForgotPassword",
        component: () => import("./pages/AffiliatePanel/AffiliateForgotPassword.vue"),
        meta: { hideFooter: true }
    },
    {
        path: "/afiliados/redefinir-senha",
        name: "AffiliateResetPassword",
        component: () => import("./pages/AffiliatePanel/AffiliateResetPassword.vue"),
        meta: { hideFooter: true }
    },
    {
        path: "/afiliados/dashboard",
        name: "AffiliateDashboard",
        component: () => import("./pages/AffiliatePanel/AffiliateDashboard.vue"),
        meta: { hideFooter: true, requiresAffiliate: true }
    },

    // ============================================
    // Admin Panel Routes (Torre de Controle)
    // ============================================
    {
        path: "/admin",
        name: "AdminLogin",
        component: () => import("./pages/AdminPanel/AdminLogin.vue"),
        meta: { hideHeader: true, hideFooter: true }
    },
    {
        path: "/admin/dashboard",
        name: "AdminDashboard",
        component: () => import("./pages/AdminPanel/AdminDashboard.vue"),
        meta: { hideHeader: true, hideFooter: true, requiresAdmin: true }
    },

    // ============================================
    // Legal Pages
    // ============================================
    {
        path: "/politica-de-privacidade",
        name: "PrivacyPolicy",
        component: () => import("./pages/PrivacyPolicy/PrivacyPolicy.vue"),
        meta: { title: 'Política de Privacidade | Unli Studios' }
    }
]